import { io, Socket } from 'socket.io-client';

class SocketService {
  private socket: Socket | null = null;

  connect(url: string, token?: string) {
    // One socket per session — once created (even while connecting), never replace it.
    // Replacing a connecting socket discards all registered listeners.
    if (this.socket) return;

    this.socket = io(url, {
      path: "/socket.io",
      auth: { token },
      transports: ['websocket'],
      secure: true,
      autoConnect: true,
      reconnection: true,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('connect_error', (err: Error) => {
      console.error('Socket connection error:', err);
    });

    // Relay call events as window CustomEvents so IncomingCallOverlay can listen
    // independently of React component lifecycle / StrictMode double-invocations.
    this.socket.on('call:incoming', (data: any) => {
      window.dispatchEvent(new CustomEvent('socket:call:incoming', { detail: data }));
    });

    this.socket.on('call:rejected', (data: any) => {
      window.dispatchEvent(new CustomEvent('socket:call:rejected', { detail: data }));
    });

    this.socket.on('call:cancelled', (data: any) => {
      window.dispatchEvent(new CustomEvent('socket:call:cancelled', { detail: data }));
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event: string, callback: (data: any) => void) {
    this.socket?.on(event, callback);
  }

  off(event: string, callback?: (data: any) => void) {
    this.socket?.off(event, callback);
  }
}

export const socketService = new SocketService();
